import BarChart from './BarChart';

export default BarChart;
export * from './BarChart';

export { default as BarLineChart } from './BarLineChart';
